import React, {Component} from 'react';
import {Table} from 'react-bootstrap';
import moment from 'moment';

class TableCentrifuge extends Component{
	constructor(props){
		super(props);

		this.removeFocus = this.removeFocus.bind(this);
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined){
      			//form.elements[index].style.boxShadow = "0 0 5px 2px rgb(255, 255, 255)";
			
				form.elements[index + 1].focus();
				form.elements[index + 1].style.boxShadow = "0 0 5px 2px rgb(104, 173, 253)";
  
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	removeFocus(e){
  		e.target.style.boxShadow = "0 0 5px 2px rgb(255, 255, 255)";
  	}

	render(){
		return (
			<div className="col-xs-12">
				<div className="col-xs-12 ">
					<input className="form-check-input" name="all"  type="checkbox" checked={this.props.state.all_check} onBlur={this.removeFocus}
						onChange={this.props.selectAll}  type="checkbox" onKeyPress={(e) => this.validateInput(e)} />
					<span className="span-min" style={{paddingLeft:"5px"}}>Seleccionar Todos</span>
				</div>
				<div className="col-xs-12 ">
					
					<Table responsive hover>
						<thead>
							<tr>
								<th></th>
								<th>Donación</th>
								<th>Fecha</th>
							</tr>
						</thead>
						<tbody>
							{
							this.props.state.centrifuges.map((c, i)=>{
								return <tr key={i}>
									<td>
										<input type="checkbox" id={c.id !== "" ? c.id : c.unit.id} onChange={this.props.checked} 
											onKeyPress={(e) => this.validateInput(e)} onBlur={this.removeFocus}
											checked={this.props.state.donations[i] !== undefined ? this.props.state.donations[i].check : ""} />
												
									</td>
									<td>
										{c.donation_number !== '' ?
											c.donation_number :
										c.unit.unit_number}
									</td>
									<td>{moment(c.timestamp_date).format('DD/MM/YYYY') }</td>
								</tr>
							})
							}
						</tbody>
					</Table>
				</div>
			</div>
		)
	}
}

export default TableCentrifuge;